import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onemonthcorporatecabrentalsinkolkata() {



  const cardData =
  {
    keyword: 'One Month Corporate Cab Rentals in Kolkata',
    heading: 'Aaryan Travels: One Month Corporate Cab Rentals in Kolkata',
    headingDescription: 'Aaryan Travels offers One Month Corporate Cab Rentals in Kolkata for businesses, IT parks, and professionals who need dependable transportation on a temporary or contract basis. Whether you require chauffeur-driven sedans for executive movement, SUVs for managerial visits, or tempo travellers for staff transport, our vehicles are available on one-month rental plans with fixed billing and flexible usage. With trained drivers, GPS tracking, and 24/7 customer support, we ensure seamless mobility across Salt Lake, New Town, Park Street, Howrah, and industrial zones. Aaryan Travels provides cost-effective and hassle-free corporate cab rentals in Kolkata for one-month or longer commitments depending on your business needs.',

    top: 'Top Places to Visit in Kolkata with Aaryan Travels',

"topPlaces": [
  {
    "title": "Victoria Memorial",
    "description": "Built in memory of Queen Victoria, the Victoria Memorial is a stunning white marble monument surrounded by lush gardens. The museum inside showcases British-era artifacts, paintings, and historical documents. At night, the monument is beautifully illuminated, creating a majestic view. The surrounding lawn is perfect for evening walks. Victoria Memorial is Kolkata’s most iconic symbol of colonial heritage and elegance."
  },
  {
    "title": "Howrah Bridge (Rabindra Setu)",
    "description": "Howrah Bridge is an engineering marvel built without nuts and bolts, connecting Kolkata and Howrah across the Hooghly River. It carries thousands of vehicles and pedestrians daily, making it one of the busiest cantilever bridges in the world. The view of the bridge lit up at night is spectacular. Howrah Bridge is Kolkata’s grand gateway of strength and connectivity."
  },
  {
    "title": "Dakshineswar Kali Temple",
    "description": "Dakshineswar Kali Temple, located on the banks of the Hooghly River, is dedicated to Goddess Bhavatarini, a form of Kali. It is associated with the revered saint Sri Ramakrishna Paramahamsa. Pilgrims visit to seek blessings and enjoy the peaceful atmosphere. The riverside ghats add to the spiritual charm. Dakshineswar Temple is Kolkata’s sacred abode of devotion."
  },
  {
    "title": "Belur Math",
    "description": "Belur Math is the headquarters of the Ramakrishna Mission, founded by Swami Vivekananda. Its architecture uniquely blends Hindu, Christian, and Islamic styles to promote unity among religions. The serene riverside setting makes it ideal for meditation and reflection. Evening prayer ceremonies are deeply soothing. Belur Math is Kolkata’s beacon of peace and spiritual harmony."
  },
  {
    "title": "Park Street",
    "description": "Park Street is Kolkata’s entertainment hub famous for its colonial-era restaurants, pubs, and nightlife. Iconic spots like Flurys, Peter Cat, and Moulin Rouge attract food lovers year-round. During Christmas and New Year, the entire street is adorned with lights and festive decor. Music, food, and celebration fill the air. Park Street is Kolkata’s lively boulevard of joy."
  },
  {
    "title": "Indian Museum",
    "description": "Established in 1814, the Indian Museum is India’s largest and oldest museum. It houses ancient sculptures, fossils, mummies, and Mughal paintings. The Egyptian mummy and dinosaur fossils are major attractions. Each gallery presents a deeply enriching historical experience. Indian Museum is Kolkata’s treasure house of heritage and knowledge."
  },
  {
    "title": "St. Paul’s Cathedral",
    "description": "St. Paul’s Cathedral is a grand Gothic-style church built in 1847. Its soaring spires, stained-glass windows, and peaceful interior make it a beautiful place for reflection. The church is especially charming during the Christmas season. It stands as a symbol of Kolkata’s colonial past and Christian legacy. St. Paul’s Cathedral is the city’s architectural gem of faith."
  },
  {
    "title": "Science City",
    "description": "Science City is India’s largest science center with interactive exhibits, 3D theaters, ropeways, and illusion tunnels. It makes learning enjoyable for both kids and adults. The Earth Exploration Hall and Space Theater are visitor favorites. The sprawling campus blends education and entertainment seamlessly. Science City is Kolkata’s futuristic world of curiosity."
  },
  {
    "title": "Kalighat Temple",
    "description": "Kalighat Temple is one of the 51 Shakti Peethas dedicated to Goddess Kali. Despite the crowds, the temple holds immense spiritual energy. Devotees come to seek blessings and fulfill vows. The nearby markets sell puja items and traditional sweets. Kalighat Temple is Kolkata’s ancient hub of divine power."
  },
  {
    "title": "Eco Park (Prakriti Tirtha)",
    "description": "Eco Park is a massive urban recreational space featuring themed gardens, lakes, adventure sports, and miniature world monuments like the Eiffel Tower. Visitors enjoy boating, cycling, and relaxing in bamboo and Japanese gardens. It’s a perfect destination for families and nature lovers. Eco Park is Kolkata’s refreshing escape into greenery."
  }
],


"services": [
  {
    "name": "One Month Corporate Cab Rentals in Kolkata",
    "description": "One Month Corporate Cab Rentals in Kolkata provide businesses with flexible and reliable cab services for a full month. Ideal for employee commutes, executive transport, and client visits, our monthly plans offer professional drivers, clean vehicles, and timely service."
  },
  {
    "name": "Kolkata Monthly Corporate Cab",
    "description": "Kolkata Monthly Corporate Cab service delivers consistent and dependable transportation solutions for companies. With premium vehicles and trained chauffeurs, we ensure smooth daily travel for staff and executives across the city."
  },
  {
    "name": "Corporate Cab Hire Kolkata Monthly",
    "description": "Corporate Cab Hire Kolkata Monthly is tailored for businesses seeking long-term cab services. Our monthly hire includes dedicated vehicles, experienced drivers, and efficient scheduling to support daily operations and employee logistics."
  },
  {
    "name": "Business Transportation Kolkata",
    "description": "Business Transportation Kolkata offers scalable cab services for companies of all sizes. Whether for staff transport, executive movement, or client travel, our business-focused cab solutions ensure punctuality and professionalism at every level."
  },
  {
    "name": "Staff Cab Services Kolkata",
    "description": "Staff Cab Services Kolkata provides safe and punctual transportation for employees. With route optimization, GPS tracking, and monthly billing, our service ensures stress-free daily commutes for your workforce across Kolkata."
  },
  {
    "name": "Chauffeur Driven Corporate Cab Kolkata",
    "description": "Chauffeur Driven Corporate Cab Kolkata offers premium cars with professional drivers trained in corporate etiquette. Ideal for executive travel and VIP guests, our service guarantees a comfortable, reliable, and professional experience."
  },
  {
    "name": "Affordable One Month Corporate Cab Kolkata",
    "description": "Affordable One Month Corporate Cab Kolkata delivers cost-effective monthly transportation without compromising on quality. Perfect for startups and SMEs, our service offers transparent pricing, dependable drivers, and clean vehicles."
  },
  {
    "name": "Executive Corporate Cab Kolkata",
    "description": "Executive Corporate Cab Kolkata caters to high-level business professionals needing refined and timely travel. Our executive cars are equipped with modern amenities and driven by courteous chauffeurs to ensure a premium experience."
  },
  {
    "name": "Company Cab Services Kolkata",
    "description": "Company Cab Services Kolkata supports businesses with tailored transportation solutions. Whether for daily commutes, meetings, or events, our fleet of corporate vehicles and professional drivers provide reliable service throughout the month."
  },
  {
    "name": "Corporate Car Rental Kolkata",
    "description": "Corporate Car Rental Kolkata offers flexible rental plans for sedans, SUVs, and premium cars. Ideal for long-term use, our rentals come with or without chauffeurs, supporting corporate mobility with ease and efficiency."
  },
  {
    "name": "Monthly Office Taxi Kolkata",
    "description": "Monthly Office Taxi Kolkata ensures regular and safe transportation for office staff. We offer scheduled pickups, well-maintained vehicles, and easy invoicing, making it the ideal choice for consistent employee travel."
  },
  {
    "name": "Online Corporate Cab Kolkata",
    "description": "Online Corporate Cab Kolkata allows easy management and booking of monthly transportation through a digital platform. Get instant confirmations, track rides, and manage accounts effortlessly with our user-friendly corporate portal."
  },
  {
    "name": "Corporate Travel Cab Kolkata",
    "description": "Corporate Travel Cab Kolkata provides end-to-end travel solutions for business needs. From airport transfers to city-wide meetings, our service ensures punctual, clean, and comfortable travel for your corporate teams."
  },
  {
    "name": "Kolkata Business Cab Monthly",
    "description": "Kolkata Business Cab Monthly is designed for businesses requiring regular travel support. Our service features timely rides, professional chauffeurs, and tailored monthly plans to meet diverse business travel needs."
  },
  {
    "name": "Premium Corporate Cab Kolkata",
    "description": "Premium Corporate Cab Kolkata offers high-end cab services for executives and VIP clients. Featuring luxury vehicles, trained chauffeurs, and impeccable service standards, this is the ideal solution for businesses seeking premium transportation."
  }
],
"tableData": [
  ["One Month Corporate Cab Rentals in Kolkata", "Kolkata Monthly Corporate Cab"],
  ["Corporate Cab Hire Kolkata Monthly", "Business Transportation Kolkata"],
  ["Staff Cab Services Kolkata", "Chauffeur Driven Corporate Cab Kolkata"],
  ["Affordable One Month Corporate Cab Kolkata", "Executive Corporate Cab Kolkata"],
  ["Company Cab Services Kolkata", "Corporate Car Rental Kolkata"],
  ["Monthly Office Taxi Kolkata", "Online Corporate Cab Kolkata"],
  ["Corporate Travel Cab Kolkata", "Kolkata Business Cab Monthly"],
  ["Premium Corporate Cab Kolkata", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "One Month Corporate Cab Rentals in Kolkata",
    "WhyChoosedescription": "Aaryan Travels offers convenient one-month corporate cab rentals in Kolkata for uninterrupted business travel."
  },
  {
    "WhyChooseheading": "Reliable and Punctual Chauffeurs",
    "WhyChoosedescription": "Our professional drivers ensure timely pickups and drop-offs to keep your corporate schedule on track."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, sanitized cars that are regularly serviced for your comfort and safety."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Kolkata Routes",
    "WhyChoosedescription": "Our drivers have extensive knowledge of Kolkata’s roads, ensuring smooth and efficient rides."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Benefit from upfront pricing that covers fuel, tolls, and driver allowances for hassle-free billing."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Bookings",
    "WhyChoosedescription": "Our support team is available around the clock to assist you with your monthly corporate cab rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans to Suit Your Needs",
    "WhyChoosedescription": "Choose plans tailored to your corporate travel requirements for maximum convenience."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Select from sedans, SUVs, or luxury vehicles to match your business travel preferences."
  }
]





































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer one month corporate cab rentals in Kolkata?',
    answer: 'Yes, Aaryan Travels provides convenient and affordable one month corporate cab rental plans in Kolkata for business needs.',
  },
  {
    question: 'How can I book one month corporate cab rentals in Kolkata with Aaryan Travels?',
    answer: 'You can book through our website, mobile app, or by contacting our 24x7 corporate customer support team.',
  },
  {
    question: 'What types of vehicles are available for one month corporate cab rentals in Kolkata?',
    answer: 'Aaryan Travels offers a range of vehicles including sedans, SUVs, and premium cars tailored for corporate travel.',
  },
  {
    question: 'Are drivers experienced with Kolkata city routes for monthly corporate rentals?',
    answer: 'Absolutely. Our professional drivers are licensed and familiar with Kolkata routes to ensure timely and comfortable rides.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for one month corporate cab rentals in Kolkata?',
    answer: 'Yes, you can specify your preferred pickup and drop-off points anywhere in Kolkata and surrounding business areas.',
  },
  {
    question: 'Is the one month corporate cab rental service available 24x7 in Kolkata?',
    answer: 'Yes, Aaryan Travels offers round-the-clock service for one month corporate cab rentals to fit your schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for one month corporate cab rentals?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene protocols to protect passengers.',
  },
  {
    question: 'What payment options are accepted for one month corporate cab rentals in Kolkata?',
    answer: 'We accept cash, corporate accounts, digital wallets, UPI, and card payments for your convenience.',
  },
  {
    question: 'Is customer support available during one month corporate cab rentals in Kolkata?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Souvik Mukherjee',
    feedback: 'Aaryan Travels’ one month corporate cab rental in Kolkata was efficient and made daily commutes hassle-free.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rina Sen',
    feedback: 'Reliable and professional service by Aaryan Travels for our corporate cab needs in Kolkata. Highly recommended!',
    rating: 5,
  },
];






















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const oneMonthCorporateCabKolkataSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "One Month Corporate Cab Rentals in Kolkata",
  "description": "Aaryan Travels provides affordable one month corporate cab rentals in Kolkata with chauffeur-driven executive cars, staff transport, and premium corporate travel solutions.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Kolkata"
  },
  "serviceType": "Monthly Corporate Cab Rental",
  "keywords": "One Month Corporate Cab Rentals in Kolkata, Kolkata Monthly Corporate Cab, Corporate Cab Hire Kolkata Monthly, Business Transportation Kolkata, Staff Cab Services Kolkata, Chauffeur Driven Corporate Cab Kolkata, Affordable One Month Corporate Cab Kolkata, Executive Corporate Cab Kolkata, Company Cab Services Kolkata, Corporate Car Rental Kolkata, Monthly Office Taxi Kolkata, Online Corporate Cab Kolkata, Corporate Travel Cab Kolkata, Kolkata Business Cab Monthly, Premium Corporate Cab Kolkata"
};







  return (
    <div>
<Helmet>
  <title>One Month Corporate Cab Rentals in Kolkata | Affordable Business Cabs | Aaryan Travels</title>
  <meta
    name="description"
    content="Book one month corporate cab rentals in Kolkata with Aaryan Travels. Chauffeur-driven executive cars, staff transport, and premium corporate travel services at affordable rates."
  />
  <meta
    name="keywords"
    content="One Month Corporate Cab Rentals in Kolkata, Kolkata Monthly Corporate Cab, Corporate Cab Hire Kolkata Monthly, Business Transportation Kolkata, Staff Cab Services Kolkata, Chauffeur Driven Corporate Cab Kolkata, Affordable One Month Corporate Cab Kolkata, Executive Corporate Cab Kolkata, Company Cab Services Kolkata, Corporate Car Rental Kolkata, Monthly Office Taxi Kolkata, Online Corporate Cab Kolkata, Corporate Travel Cab Kolkata, Kolkata Business Cab Monthly, Premium Corporate Cab Kolkata"
  />
  <script type="application/ld+json">
    {JSON.stringify(oneMonthCorporateCabKolkataSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/55.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onemonthcorporatecabrentalsinkolkata;